import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import uniqBy from 'lodash/uniqBy';

import InsuranceDeviceForm from 'components/InsuranceDeviceForm';
import { findContract } from 'actions/insuranceContracts';
import { createDevice } from 'actions/insuranceDevices';
import { fetchAllDevices } from 'actions/devices';
import { getSubmitStatus, getAllDevices, getContract } from 'reducers';

class CreateDevice extends Component {
  constructor(props) {
    super(props);

    this.setBrand = this.setBrand.bind(this);

    this.state = {
      brand: '',
    };
  }

  get devices() {
    const { devices } = this.props;
    const { brand } = this.state;

    if (brand === '') return devices;
    return devices.filter((device) => device.brand === brand);
  }

  get brands() {
    const { devices } = this.props;

    let sortedAndFilteredDevices = uniqBy(devices, 'brand');

    sortedAndFilteredDevices.sort((a, b) => {
      if (a.brand < b.brand) {
        return -1;
      }
      if (a.brand > b.brand) {
        return 1;
      }

      return 0;
    });

    return sortedAndFilteredDevices;
  }

  setBrand(brand) {
    this.setState({ brand });
  }

  componentDidMount() {
    this.props.findContract(this.props.match.params.id);
    this.props.fetchAllDevices();
  }

  render() {
    const { saveStatus, onSubmit, contract } = this.props;
    if (!contract) {
      return <div>Loading</div>;
    }

    if (saveStatus === 'SUCCEEDED') {
      return (
        <Redirect to={`/device-protection/contracts/${contract.id}/view`} />
      );
    }

    const initialValues = {
      contract: this.props.match.params.id,
      user_profile: contract.user_profile,
    };

    return (
      <div>
        <h1 className="mar-b">Add Device</h1>
        <InsuranceDeviceForm
          saveStatus={saveStatus}
          initialValues={initialValues}
          setBrand={this.setBrand}
          brands={this.brands}
          devices={this.devices}
          onSubmit={onSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => ({
  saveStatus: getSubmitStatus(state, 'insuranceDevice'),
  devices: getAllDevices(state),
  contract: getContract(state, id),
});

const mapDispatchToProps = {
  onSubmit: createDevice,
  findContract,
  fetchAllDevices,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDevice);
